import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const danhMucMenu: NavMenu = {
  title: 'Danh mục',
  items: [
    {
      title: 'Đối tượng',
      group: 0,
      items: [
        {
          title: 'Khách hàng',
          icon: <AritoIcon icon={828} />,
          href: '/danh-muc/doi-tuong/khach-hang'
        },
        {
          title: 'Nhà cung cấp',
          icon: <AritoIcon icon={385} />,
          href: '/danh-muc/doi-tuong/nha-cung-cap'
        },
        {
          title: 'Vật tư, sản phẩm',
          icon: <AritoIcon icon={155} />,
          href: '/danh-muc/doi-tuong/vat-tu-san-pham'
        },
        {
          title: 'Nhân viên',
          icon: <AritoIcon icon={825} />,
          href: '/danh-muc/doi-tuong/nhan-vien'
        },
        {
          title: 'Dịch vụ',
          icon: <AritoIcon icon={547} />,
          href: '/danh-muc/doi-tuong/dich-vu'
        },
        {
          title: 'Hệ thống tài khoản',
          icon: <AritoIcon icon={46} />,
          href: '/danh-muc/doi-tuong/he-thong-tai-khoan'
        },
        {
          title: 'Bộ phận kế toán',
          icon: <AritoIcon icon={711} />,
          href: '/danh-muc/doi-tuong/bo-phan-ke-toan'
        },
        {
          title: 'Khế ước',
          icon: <AritoIcon icon={531} />,
          href: '/danh-muc/doi-tuong/khe-uoc'
        },
        {
          title: 'Tỷ giá quy đổi ngoại tệ',
          icon: <AritoIcon icon={274} />,
          href: '/danh-muc/doi-tuong/ty-gia-quy-doi-ngoai-te'
        }
      ]
    },
    {
      title: 'Kế toán',
      icon: <AritoIcon icon={70} />,
      group: 0,
      items: [
        {
          title: 'Ngoại tệ',
          icon: <AritoIcon icon={273} />,
          href: '/danh-muc/ke-toan/ngoai-te'
        },
        {
          title: 'Phí',
          icon: <AritoIcon icon={52} />,
          href: '/danh-muc/ke-toan/phi'
        },
        {
          title: 'Nhóm phí',
          icon: <AritoIcon icon={73} />,
          href: '/danh-muc/ke-toan/nhom-phi'
        },
        {
          title: 'Thu chi',
          icon: <AritoIcon icon={73} />,
          href: '/danh-muc/ke-toan/thu-chi'
        }
      ]
    },
    {
      title: 'Vật tư, sản phẩm và kho',
      icon: <AritoIcon icon={394} />,
      group: 0,
      items: [
        {
          title: 'Vật tư, sản phẩm',
          icon: <AritoIcon icon={155} />,
          href: '/danh-muc/vat-tu-san-pham-va-kho/vat-tu-san-pham'
        },
        {
          title: 'Phân nhóm vật tư, hàng hoá',
          icon: <AritoIcon icon={539} />,
          href: '/danh-muc/vat-tu-san-pham-va-kho/phan-nhom-vat-tu-hang-hoa'
        },
        {
          title: 'Lô hàng',
          icon: <AritoIcon icon={618} />,
          href: '/danh-muc/vat-tu-san-pham-va-kho/lo-hang'
        },
        {
          title: 'Kho hàng',
          icon: <AritoIcon icon={395} />,
          href: '/danh-muc/vat-tu-san-pham-va-kho/kho-hang'
        },
        {
          title: 'Nhóm kho hàng',
          icon: <AritoIcon icon={539} />,
          href: '/danh-muc/vat-tu-san-pham-va-kho/nhom-kho-hang'
        }
      ]
    },
    {
      title: 'Khai báo kho, vật tư',
      icon: <AritoIcon icon={199} />,
      group: 1,
      items: [
        {
          title: 'Đơn vị tính',
          icon: <AritoIcon icon={83} />,
          href: '/danh-muc/khai-bao-kho-vat-tu/don-vi-tinh'
        },
        {
          title: 'Loại vật tư',
          icon: <AritoIcon icon={431} />,
          href: '/danh-muc/khai-bao-kho-vat-tu/loai-vat-tu'
        },
        {
          title: 'Quy đổi đơn vị tính chung',
          icon: <AritoIcon icon={119} />,
          href: '/danh-muc/khai-bao-kho-vat-tu/quy-doi-don-vi-tinh-chung'
        },
        {
          title: 'Quy đổi đơn vị tính chi tiết',
          icon: <AritoIcon icon={121} />,
          href: '/danh-muc/khai-bao-kho-vat-tu/quy-doi-don-vi-tinh-chi-tiet'
        },
        {
          title: 'Lý do nhập/xuất',
          icon: <AritoIcon icon={631} />,
          href: '/danh-muc/khai-bao-kho-vat-tu/ly-do-nhap-xuat'
        },
        {
          title: 'Thông tin vật tư theo đơn vị',
          icon: <AritoIcon icon={47} />,
          href: '/danh-muc/khai-bao-kho-vat-tu/thong-tin-vat-tu-theo-don-vi'
        },
        {
          title: 'Khai báo mã hàng IPOS',
          icon: <AritoIcon icon={431} />,
          href: '/danh-muc/khai-bao-kho-vat-tu/khai-bao-ma-hang-ipos'
        }
      ]
    },
    {
      title: 'Bán hàng',
      icon: <AritoIcon icon={207} />,
      group: 1,
      items: [
        {
          title: 'Giá bán',
          icon: <AritoIcon icon={273} />,
          href: '/danh-muc/ban-hang/gia-ban'
        },
        {
          title: 'Phân nhóm khách hàng',
          icon: <AritoIcon icon={539} />,
          href: '/danh-muc/ban-hang/phan-nhom-khach-hang'
        },
        {
          title: 'Hạn thanh toán',
          icon: <AritoIcon icon={544} />,
          href: '/danh-muc/ban-hang/han-thanh-toan'
        },
        {
          title: 'Phương thức thanh toán',
          icon: <AritoIcon icon={626} />,
          href: '/danh-muc/ban-hang/phuong-thuc-thanh-toan'
        },
        {
          title: 'Phương thức giao hàng',
          icon: <AritoIcon icon={824} />,
          href: '/danh-muc/ban-hang/phuong-thuc-giao-hang'
        },
        {
          title: 'Phương tiện vận chuyển',
          icon: <AritoIcon icon={822} />,
          href: '/danh-muc/ban-hang/phuong-tien-van-chuyen'
        },
        {
          title: 'Địa chỉ giao hàng',
          icon: <AritoIcon icon={480} />,
          href: '/danh-muc/ban-hang/dia-chi-giao-hang'
        },
        {
          title: 'Khu vực',
          icon: <AritoIcon icon={232} />,
          href: '/danh-muc/ban-hang/khu-vuc'
        },
        {
          title: 'Danh mục nguồn đơn',
          icon: <AritoIcon icon={232} />,
          href: '/danh-muc/ban-hang/danh-muc-nguon-don'
        },
        {
          title: 'Danh mục tài khoản chi tiết theo cửa hàng',
          icon: <AritoIcon icon={232} />,
          href: '/danh-muc/ban-hang/danh-muc-tai-khoan-chi-tiet-theo-cua-hang'
        },
        {
          title: 'Danh mục kênh bán hàng',
          icon: <AritoIcon icon={232} />,
          href: '/danh-muc/ban-hang/danh-muc-kenh-ban-hang'
        }
      ]
    },
    {
      title: 'Mua hàng',
      icon: <AritoIcon icon={638} />,
      group: 1,
      items: [
        {
          title: 'Giá mua',
          icon: <AritoIcon icon={539} />,
          href: '/danh-muc/mua-hang/gia-mua'
        },
        {
          title: 'Phân nhóm nhà cung cấp',
          icon: <AritoIcon icon={539} />,
          href: '/danh-muc/mua-hang/phan-nhom-nha-cung-cap'
        },
        {
          title: 'Địa chỉ nhận hàng',
          icon: <AritoIcon icon={480} />,
          href: '/danh-muc/mua-hang/dia-chi-nhan-hang'
        },
        {
          title: 'Chi phí mua hàng',
          icon: <AritoIcon icon={636} />,
          href: '/danh-muc/mua-hang/chi-phi-mua-hang'
        }
      ]
    },
    {
      title: 'Hợp đồng/ Khế ước',
      icon: <AritoIcon icon={764} />,
      group: 1,
      items: [
        {
          title: 'Khế ước',
          icon: <AritoIcon icon={767} />,
          href: '/danh-muc/hop-dong-khe-uoc/khe-uoc'
        },
        {
          title: 'Đợt thanh toán',
          icon: <AritoIcon icon={768} />,
          href: '/danh-muc/hop-dong-khe-uoc/dot-thanh-toan'
        }
      ]
    },
    {
      title: 'Thuế',
      icon: <AritoIcon icon={81} />,
      group: 2,
      items: [
        {
          title: 'Danh mục thuế suất',
          icon: <AritoIcon icon={263} />,
          href: '/danh-muc/thue/danh-muc-thue-suat'
        },
        {
          title: 'Thuế suất thuế GTGT',
          icon: <AritoIcon icon={263} />,
          href: '/danh-muc/thue/thue-suat-thue-gtgt'
        },
        {
          title: 'Nhóm thuế',
          icon: <AritoIcon icon={116} />,
          href: '/danh-muc/thue/nhom-thue'
        },
        {
          title: 'Thuế suất thuế nhập khẩu',
          icon: <AritoIcon icon={264} />,
          href: '/danh-muc/thue/thue-suat-thue-nhap-khau'
        },
        {
          title: 'Thuế suất thuế tiêu thụ đặc biệt',
          icon: <AritoIcon icon={265} />,
          href: '/danh-muc/thue/thue-suat-thue-tieu-thu-dac-biet'
        },
        {
          title: 'Tính chất thuế',
          icon: <AritoIcon icon={126} />,
          href: '/danh-muc/thue/tinh-chat-thue'
        },
        {
          title: 'Mẫu số hoá đơn',
          icon: <AritoIcon icon={310} />,
          href: '/danh-muc/thue/mau-so-hoa-don'
        }
      ]
    },
    {
      title: 'Ngân hàng',
      icon: <AritoIcon icon={90} />,
      group: 2,
      items: [
        {
          title: 'Danh mục ngân hàng',
          icon: <AritoIcon icon={192} />,
          href: '/danh-muc/ngan-hang/danh-muc-ngan-hang'
        },
        {
          title: 'Tài khoản ngân hàng',
          icon: <AritoIcon icon={192} />,
          href: '/danh-muc/ngan-hang/tai-khoan-ngan-hang'
        },
        {
          title: 'Phí ngân hàng',
          icon: <AritoIcon icon={203} />,
          href: '/danh-muc/ngan-hang/phi-ngan-hang'
        }
      ]
    },
    {
      title: 'Tài sản & công cụ',
      icon: <AritoIcon icon={746} />,
      group: 2,
      items: [
        {
          title: 'Loaị TSCĐ/CCDC',
          icon: <AritoIcon icon={110} />,
          href: '/danh-muc/tai-san-cong-cu/loai-tscd-ccdc',
          group: 0
        },
        {
          title: 'Nhóm TSCĐ',
          icon: <AritoIcon icon={538} />,
          href: '/danh-muc/tai-san-cong-cu/nhom-tscd',
          group: 0
        },
        {
          title: 'Lý do tăng giảm TSCĐ',
          icon: <AritoIcon icon={55} />,
          href: '/danh-muc/tai-san-cong-cu/ly-do-tang-giam-tscd',
          group: 0
        },
        {
          title: 'Bộ phận sử dụng TSCĐ',
          icon: <AritoIcon icon={455} />,
          href: '/danh-muc/tai-san-cong-cu/bo-phan-su-dung-tscd',
          group: 0
        },
        {
          title: 'Nhóm CCDC',
          icon: <AritoIcon icon={573} />,
          href: '/danh-muc/tai-san-cong-cu/nhom-ccdc',
          group: 1
        },
        {
          title: 'Lý do tăng giảm CCDC',
          icon: <AritoIcon icon={55} />,
          href: '/danh-muc/tai-san-cong-cu/ly-do-tang-giam-ccdc',
          group: 1
        },
        {
          title: 'Bộ phận sử dụng CCDC',
          icon: <AritoIcon icon={455} />,
          href: '/danh-muc/tai-san-cong-cu/bo-phan-su-dung-ccdc',
          group: 1
        }
      ]
    },
    {
      title: 'Khác',
      icon: <AritoIcon icon={575} />,
      group: 3,
      items: [
        {
          title: 'Quốc gia',
          icon: <AritoIcon icon={838} />,
          href: '/danh-muc/khac/quoc-gia'
        },
        { title: 'Danh muc Tỉnh/Thành', icon: <AritoIcon icon={199} />, href: '/danh-muc/khac/danh-muc-tinh-thanh' },
        {
          title: 'Cơ quan thuế',
          icon: <AritoIcon icon={158} />,
          href: '/danh-muc/khac/co-quan-thue'
        },
        {
          title: 'Thông tin nộp thuế',
          icon: <AritoIcon icon={631} />,
          href: '/danh-muc/khac/thong-tin-nop-thue'
        },
        { title: 'Danh mục Quận/Huyện', icon: <AritoIcon icon={199} />, href: '/danh-muc/khac/danh-muc-quan-huyen' },
        { title: 'Danh mục xã/phường', icon: <AritoIcon icon={199} />, href: '/danh-muc/khac/danh-muc-xa-phuong' }
      ]
    }
  ]
};
